export default {}
export const API_ENV_NAME = process.env.VUE_APP_ENV_NAME;
export const API_URL = process.env.VUE_APP_API_URI;
export const API_MS_URL = process.env.VUE_APP_API_MS_URL;
export const API_SS_URL = process.env.VUE_APP_API_SS_URL;
export const API_NLP_URL = process.env.VUE_APP_API_NLP_URL;
export const PASS_REGEX = process.env.VUE_APP_PASS_REGEX;
export const APP_URL = process.env.VUE_APP_URL;
export const APP_RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
